import React from 'react';
import { useIntl } from 'react-intl';

export default function injectIntl(Component) {
  // Compatibility wrapper for react-intl v10: the upstream injectIntl export was removed, but legacy class components in this app still expect an intl prop.
  function InjectIntl(props) {
    const intl = useIntl();

    return <Component {...props} intl={intl} />;
  }

  InjectIntl.displayName = `InjectIntl(${Component.displayName || Component.name || 'Component'})`;

  return InjectIntl;
}
